import QrCode from "components/QrCode";
import React from "react";

function DepositQrCode({ selectedWallet }) {
  return (
    <QrCode value={selectedWallet?.address} text={selectedWallet?.address} />
  );
}

export default DepositQrCode;
